__webpack_require__.p = "https://static.parastorage.com/services/restaurants-orders-ooi/24a109c0976215e71355c5fb2e406d15ad07a1c710b2211c1b7c6ed6/";